import { produce } from 'immer';

import { UpdateInternalMarketerProductAccess } from '../../../actions/marketer/internal/updateInternalMarketerProductAccess';
import { MarketersPageStates, MarketerState } from '../../../typings/marketers';

export function updateInternalMarketerProductAccess(
    state: MarketerState,
    action: UpdateInternalMarketerProductAccess
): MarketerState {
    return produce(state, draft => {
        draft.pageStatus = MarketersPageStates.ACTION;
    });
}
